module.exports = __webpack_public_path__ + "static/media/3.19987d34.png";